import { useState } from 'react'

// Opcoes fixas de linhas por pagina, usadas em toda planilha de exibicao do site.
export const OPCOES_TAMANHO_PAGINA = [15, 30, 50, 75, 100]

// Pagina uma lista ja filtrada/ordenada. Trocar o tamanho da pagina sempre volta pra pagina 1;
// se um filtro reduzir o total de itens e a pagina atual ficar "fora" do intervalo (ex.: estava na
// pagina 5 e sobraram so 2 paginas), a pagina exibida e recalculada (Math.min) sem precisar de
// efeito nenhum — evita o "pagina em branco" sem re-render extra.
export function usePaginacao(itens, tamanhoPadrao = 30) {
  const [pagina, setPagina] = useState(1)
  const [tamanhoPagina, setTamanhoPaginaState] = useState(tamanhoPadrao)
  const setTamanhoPagina = (novo) => { setTamanhoPaginaState(novo); setPagina(1) }

  const totalItens = itens.length
  const totalPaginas = Math.max(1, Math.ceil(totalItens / tamanhoPagina))
  const paginaAtual = Math.min(pagina, totalPaginas)
  const inicio = (paginaAtual - 1) * tamanhoPagina
  const itensPagina = itens.slice(inicio, inicio + tamanhoPagina)

  return { pagina: paginaAtual, setPagina, tamanhoPagina, setTamanhoPagina, itensPagina, totalPaginas, totalItens, inicio }
}

// Barra "Mostrar N por página · X–Y de Z" + navegação, pra ficar debaixo de toda tabela paginada.
export default function Paginacao({ pagina, totalPaginas, totalItens, tamanhoPagina, setPagina, setTamanhoPagina, inicio, rotulo = 'registro', rotuloPlural }) {
  if (totalItens === 0) return null
  const fim = Math.min(inicio + tamanhoPagina, totalItens)
  const plural = rotuloPlural || `${rotulo}s`
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginTop: 14, paddingTop: 14, borderTop: '1px solid #eee' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#888' }}>
        <span>Mostrar</span>
        <select
          className="form-select"
          style={{ width: 'auto', padding: '4px 8px', fontSize: 12 }}
          value={tamanhoPagina}
          onChange={e => setTamanhoPagina(Number(e.target.value))}
        >
          {OPCOES_TAMANHO_PAGINA.map(n => <option key={n} value={n}>{n}</option>)}
        </select>
        <span>por página &middot; {inicio + 1}&ndash;{fim} de {totalItens} {totalItens === 1 ? rotulo : plural}</span>
      </div>
      {totalPaginas > 1 && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <button type="button" className="btn btn-secondary btn-sm" disabled={pagina <= 1} onClick={() => setPagina(1)}>«</button>
          <button type="button" className="btn btn-secondary btn-sm" disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)}>‹</button>
          <span style={{ fontSize: 12, color: '#888', padding: '0 6px' }}>Página {pagina} de {totalPaginas}</span>
          <button type="button" className="btn btn-secondary btn-sm" disabled={pagina >= totalPaginas} onClick={() => setPagina(pagina + 1)}>›</button>
          <button type="button" className="btn btn-secondary btn-sm" disabled={pagina >= totalPaginas} onClick={() => setPagina(totalPaginas)}>»</button>
        </div>
      )}
    </div>
  )
}
